module.exports = __webpack_public_path__ + "img/britain-flag.f15b6916.svg";